class InfosProductController {
  voucherInfos;
  isPromoted;
  productRef;
  promotedPrice;
  productList;
  canal;
  availableOnAllProducts;
  constructor ($scope, Localization, VoucherFactory, ProductService, VoucherService, VehicleService, $location, I18n, ProductUtilsService, $log, PurchaseInfos) {
    'ngInject'
    this.country = Localization.getCountry()
    this.voucherFactory = VoucherFactory
    this.productService = ProductService
    this.voucherService = VoucherService
    this.vehicleService = VehicleService
    this.productUtilsService = ProductUtilsService
    this.i18n = I18n
    this.isProcessing = false
    this.$location = $location
    this.voucherValid = false
    this.isTryAndBuy = false
    this.$log = $log
    this.purchaseInfos = PurchaseInfos
    this.voucherFree = false
    this.B2BPrice = NaN
    this.isPro = false
    this.isFreeProduct = false
    this.buyingCountry = null
    $scope.$on('buy-product:countryChanged', (evt, data) => {
      this.buyingCountry = data
      this.B2BPriceComputationTriggered()
    })
    $scope.$on('buy-product:proToggled', (evt, data) => {
      this.isPro = data
      this.B2BPriceComputationTriggered()
    })
  }

  $onInit () {
    this.getProduct()
  }

  B2BPriceComputationTriggered () {
    if (!this.product) return
    if (!this.buyingCountry) return
    if (this.shouldComputeB2BPrice()) {
      if (!this.purchaseInfos.loadingB2BPrice) {
        this.purchaseInfos.loadingB2BPrice = true
        this.productService.getB2BPrice(this.productRef, this.buyingCountry)
        .then((res) => {
          this.product.B2BPrice = res
          this.purchaseInfos.loadingB2BPrice = false
          this.computeProductPrice()
          if (this.voucherValid) {
            this.updateVoucher()
          }
        }, (err) => { // FIXME error
          this.error = err
          this.purchaseInfos.loadingB2BPrice = false
        })
      }
    } else {
      this.computeProductPrice()
      if (this.voucherValid) {
        this.updateVoucher()
      }
    }
  }

  getProduct () {
    if (!isNaN(parseInt(this.productRef, 10))) {
      const vin = this.vehicleService.getCurrentVin()
      return this.productService.getProduct(this.productRef, vin, this.i18n.getLanguage())
      .then((success) => {
        this.product = success
        this.product.B2BPrice = NaN
        this.isTryAndBuy = this.productUtilsService.getTryAndBuy(this.product)
        this.isFreeProduct = this.isFree()
        this.computeProductPrice()
      }, (err) => {
        this.$log.error('error get product ', err)
        this.error = err
      })
    } else {
      this.$location.path('/error')
    }
  }

  shouldComputeB2BPrice () {
    return this.isPro && !(this.isFreeProduct || this.voucherFree)
  }

  computeProductPrice () {
    this.priceProductLabel = this.getPriceLabel(this.product.price)
    if (this.priceProductLabel !== 'catalog.product.free') {
      this.currency = this.product.price.substring(this.product.price.indexOf(' '))
      this.priceProduct = parseFloat(this.product.price)
      if (!isNaN(this.product.B2BPrice) && this.shouldComputeB2BPrice()) {
        this.priceProduct = this.product.B2BPrice
        this.priceProductLabel = this.product.B2BPrice + this.currency
      }
      if (this.product.isPromoted) {
        this.pricePromotionLabel = this.getPriceLabel(this.product.promotedPrice)
        if (this.pricePromotionLabel !== 'catalog.product.free') {
          this.voucherFree = false
          this.pricePromotion = Math.round((parseFloat(this.product.promotedPrice) - parseFloat(this.product.price)) * 100) / 100
          this.pricePromotionLabel = this.pricePromotion.toFixed(2) + this.currency
          this.totalToPay = (Math.round((this.priceProduct + this.pricePromotion) * 100) / 100).toFixed(2) + this.currency
        } else {
          this.voucherFree = true
          this.totalToPay = this.pricePromotionLabel
        }
      } else {
        this.totalToPay = this.priceProductLabel
      }
    } else {
      this.totalToPay = this.priceProductLabel
    }
    this.totalPrice = this.totalToPay
  }

  getPriceLabel (price) {
    return price && (price.match(/free/i) || parseFloat(price.replace(/,/g, '.')) === 0)
      ? 'catalog.product.free'
      : price
  }

  /**
   * Calculation of the price after a voucher has been applied
   * @param price Initial price of the product
   */
  doCalcPriceWithVoucher (price) {
    this.amountReduction = this.voucherFactory.getReductionPrice(this.voucherResponse.value, price)
    this.priceVoucher = (Math.round((parseFloat(this.amountReduction) - parseFloat(price)) * 100) / 100).toFixed(2) + this.currency
    this.totalToPay = (Math.round((parseFloat(price) + parseFloat(this.priceVoucher)) * 100) / 100).toFixed(2) + this.currency
    if (parseFloat(this.totalToPay) === 0) {
      this.totalToPay = 'catalog.product.free'
    }
  }

  voucherSubmit (form) {
    if (form.voucherForm.$valid) {
      this.isProcessing = true
      return this.voucherService.consulteVoucherCode(this.vouchercode)
      .then((res) => {
        this.error = null
        this.isProcessing = false
        this.voucherResponse = res
        this.voucherValid = false
        this.updateVoucher()
      }, (err) => {
        this.isProcessing = false
        this.$log.error('error voucher ', err)
        this.voucherResponse = err.data
      })
    }
    if ('error'.indexOf(this.messageErrorVoucher) === 0) {
      this.cancelVoucher()
    }
  }

  updateVoucher () {
    if (!this.voucherResponse.error) {
      this.messageErrorVoucher = ''
      if (this.voucherFactory.validateCountryVoucher(this.country, this.voucherResponse.country)) {
        if (this.voucherResponse.productList === undefined || this.voucherResponse.productList.length === 0 || this.voucherFactory.validateProductRefFromVoucher(this.voucherResponse.productList, this.productRef)) {
          this.voucherValid = true
          // New price calculation
          if (this.product.isPromoted) {
            this.$log.debug('this.voucherResponse.availableOnAllProducts', this.voucherResponse.availableOnAllProducts)
            if (this.voucherResponse.availableOnAllProducts) {
              this.doCalcPriceWithVoucher(this.product.promotedPrice)
            } else {
              this.voucherValid = false
              this.messageErrorVoucher = 'productAlreadyPromotion'
            }
          } else {
            this.doCalcPriceWithVoucher(this.priceProduct + ' ' + this.currency)
          }
          this.activeVoucher = false
        } else {
          this.messageErrorVoucher = 'noMatchForProduct'
        }
      } else {
        this.messageErrorVoucher = 'noMatchForCountry'
      }
      // infos voucher
      this.voucherInfos.isPurchaseUsingVoucher = this.voucherValid
      this.voucherInfos.amountReduction = this.amountReduction
      this.voucherInfos.canalCode = this.voucherResponse.canal
      this.voucherInfos.voucherCode = this.vouchercode
    } else {
      this.messageErrorVoucher = this.voucherResponse.error.errorCode
    }
  }

  cancelVoucher () {
    this.activeVoucher = false
    this.isProcessing = false
    this.voucherResponse = {}
    this.messageErrorVoucher = ''
    this.vouchercode = ''
    this.voucherValid = false
    this.totalToPay = this.totalPrice
    this.initVoucherInfos()
  }

  initVoucherInfos () {
    this.voucherInfos.isPurchaseUsingVoucher = false
    this.voucherInfos.amountReduction = ''
    this.voucherInfos.canalCode = ''
    this.voucherInfos.voucherCode = ''
  }

  isFree () {
    return (this.isTryAndBuy || this.isFreePrice(this.product.price) || (this.product.isPromoted && this.isFreePrice(this.product.promotedPrice)))
  }

  isFreePrice (price) {
    const priceProduct = price.replace(/,/g, '.')
    return price.match(/free/i) || parseFloat(priceProduct) === 0
  }
}

export default InfosProductController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/infos-product/infos-product.controller.js